<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkArticlesRankingSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    rankingType: 'Date',
    quantity: 5,
    showPicture: false
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

const rankingTypeOptions = computed<any[]>(() =>
{
    return [
        { value: 'Views', text: $t('[[[Liczba wyświetleń]]]') },
        { value: 'UserInteraction', text: $t('[[[Interakcja użytkownika (Komenatrze, Like)]]]') },
        { value: 'TimeSpent', text: $t('[[[Czas na stronie]]]') }
    ];
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function rankingTypeChanged(): Promise<void>
{
    form.value.settings = {
        rankingType: form.value.settings.rankingType
    };
}
onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup>
        <IdeoFormCheckbox v-model="form.settings.showPicture">
            {{ $t('[[[Wyświetlaj listę artykułów z miniaturką zdjęcia]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>

    <hr>

    <IdeoFormGroup :label="$t('[[[Typ rankingu]]]')" :invalid-feedback="form.$errors.first('settings.rankingType')" :state="form.$errors.state('settings.rankingType')">
        <IdeoFormSelect v-model="form.settings.rankingType" :options="rankingTypeOptions" value-field="value" text-field="text" @change="rankingTypeChanged" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Ilość wyświetlanych artykułów]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <IdeoFormInput v-model="form.settings.quantity" name="quantity" type="number" />
    </IdeoFormGroup>
</template>
